// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as R360LeaderCheckRouteImport } from './routes/360-leader-check'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as Begin360CheckRouteImport } from './routes/begin-360-check'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as GrowRouteImport } from './routes/grow'
import { Route as InsightRouteImport } from './routes/insight'
import { Route as LeadershipGapsAssessmentRouteImport } from './routes/leadership-gaps-assessment'
import { Route as PilotRouteImport } from './routes/pilot'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PurchaseRouteImport } from './routes/purchase'
import { Route as ResourcesRouteImport } from './routes/resources'
import { Route as ScheduleRouteImport } from './routes/schedule'
import { Route as SolutionsRouteImport } from './routes/solutions'
import { Route as StartRouteImport } from './routes/start'
import { Route as TermsAndConditionsRouteImport } from './routes/terms-and-conditions'
import { Route as AuthorSlugRouteImport } from './routes/author.$slug'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as CaseStudiesIndexRouteImport } from './routes/case-studies.index'
import { Route as CaseStudiesSlugRouteImport } from './routes/case-studies.$slug'
import { Route as CourseCatalogIndexRouteImport } from './routes/course-catalog.index'
import { Route as CourseCatalogSlugRouteImport } from './routes/course-catalog.$slug'
import { Route as ProblemsIndexRouteImport } from './routes/problems.index'
import { Route as ProblemsSlugRouteImport } from './routes/problems.$slug'
import { Route as ReviewTokenRouteImport } from './routes/review.$token'
import { Route as WhoWeHelpSlugRouteImport } from './routes/who-we-help.$slug'
import { Route as AuthenticatedAdminDemoRouteImport } from './routes/_authenticated/admin.demo'
import { Route as AuthenticatedAdminReviewRouteImport } from './routes/_authenticated/admin.review'
import { Route as AuthenticatedAdminScheduleRouteImport } from './routes/_authenticated/admin.schedule'
import { Route as AuthenticatedMyReviewIndexRouteImport } from './routes/_authenticated/my-review.index'
import { Route as AuthenticatedWatchPartyIndexRouteImport } from './routes/_authenticated/watch-party.index'
import { Route as AuthenticatedMyReviewCycleIdIndexRouteImport } from './routes/_authenticated/my-review.$cycleId.index'
import { Route as AuthenticatedMyReviewCycleIdResultsRouteImport } from './routes/_authenticated/my-review.$cycleId.results'
import { Route as AuthenticatedWatchPartyPartyIdIndexRouteImport } from './routes/_authenticated/watch-party.$partyId.index'
import { Route as AuthenticatedWatchPartyPartyIdRecapRouteImport } from './routes/_authenticated/watch-party.$partyId.recap'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const R360LeaderCheckRoute = R360LeaderCheckRouteImport.update({
            id: '/360-leader-check',path: '/360-leader-check',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AboutUsRoute = AboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const Begin360CheckRoute = Begin360CheckRouteImport.update({
            id: '/begin-360-check',path: '/begin-360-check',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const GrowRoute = GrowRouteImport.update({
            id: '/grow',path: '/grow',getParentRoute: () => rootRouteImport
          })
const InsightRoute = InsightRouteImport.update({
            id: '/insight',path: '/insight',getParentRoute: () => rootRouteImport
          })
const LeadershipGapsAssessmentRoute = LeadershipGapsAssessmentRouteImport.update({
            id: '/leadership-gaps-assessment',path: '/leadership-gaps-assessment',getParentRoute: () => rootRouteImport
          })
const PilotRoute = PilotRouteImport.update({
            id: '/pilot',path: '/pilot',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const PurchaseRoute = PurchaseRouteImport.update({
            id: '/purchase',path: '/purchase',getParentRoute: () => rootRouteImport
          })
const ResourcesRoute = ResourcesRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => rootRouteImport
          })
const ScheduleRoute = ScheduleRouteImport.update({
            id: '/schedule',path: '/schedule',getParentRoute: () => rootRouteImport
          })
const SolutionsRoute = SolutionsRouteImport.update({
            id: '/solutions',path: '/solutions',getParentRoute: () => rootRouteImport
          })
const StartRoute = StartRouteImport.update({
            id: '/start',path: '/start',getParentRoute: () => rootRouteImport
          })
const TermsAndConditionsRoute = TermsAndConditionsRouteImport.update({
            id: '/terms-and-conditions',path: '/terms-and-conditions',getParentRoute: () => rootRouteImport
          })
const AuthorSlugRoute = AuthorSlugRouteImport.update({
            id: '/author/$slug',path: '/author/$slug',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const CaseStudiesIndexRoute = CaseStudiesIndexRouteImport.update({
            id: '/case-studies/',path: '/case-studies/',getParentRoute: () => rootRouteImport
          })
const CaseStudiesSlugRoute = CaseStudiesSlugRouteImport.update({
            id: '/case-studies/$slug',path: '/case-studies/$slug',getParentRoute: () => rootRouteImport
          })
const CourseCatalogIndexRoute = CourseCatalogIndexRouteImport.update({
            id: '/course-catalog/',path: '/course-catalog/',getParentRoute: () => rootRouteImport
          })
const CourseCatalogSlugRoute = CourseCatalogSlugRouteImport.update({
            id: '/course-catalog/$slug',path: '/course-catalog/$slug',getParentRoute: () => rootRouteImport
          })
const ProblemsIndexRoute = ProblemsIndexRouteImport.update({
            id: '/problems/',path: '/problems/',getParentRoute: () => rootRouteImport
          })
const ProblemsSlugRoute = ProblemsSlugRouteImport.update({
            id: '/problems/$slug',path: '/problems/$slug',getParentRoute: () => rootRouteImport
          })
const ReviewTokenRoute = ReviewTokenRouteImport.update({
            id: '/review/$token',path: '/review/$token',getParentRoute: () => rootRouteImport
          })
const WhoWeHelpSlugRoute = WhoWeHelpSlugRouteImport.update({
            id: '/who-we-help/$slug',path: '/who-we-help/$slug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminDemoRoute = AuthenticatedAdminDemoRouteImport.update({
            id: '/admin/demo',path: '/admin/demo',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminReviewRoute = AuthenticatedAdminReviewRouteImport.update({
            id: '/admin/review',path: '/admin/review',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminScheduleRoute = AuthenticatedAdminScheduleRouteImport.update({
            id: '/admin/schedule',path: '/admin/schedule',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMyReviewIndexRoute = AuthenticatedMyReviewIndexRouteImport.update({
            id: '/my-review/',path: '/my-review/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedWatchPartyIndexRoute = AuthenticatedWatchPartyIndexRouteImport.update({
            id: '/watch-party/',path: '/watch-party/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMyReviewCycleIdIndexRoute = AuthenticatedMyReviewCycleIdIndexRouteImport.update({
            id: '/my-review/$cycleId/',path: '/my-review/$cycleId/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMyReviewCycleIdResultsRoute = AuthenticatedMyReviewCycleIdResultsRouteImport.update({
            id: '/my-review/$cycleId/results',path: '/my-review/$cycleId/results',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedWatchPartyPartyIdIndexRoute = AuthenticatedWatchPartyPartyIdIndexRouteImport.update({
            id: '/watch-party/$partyId/',path: '/watch-party/$partyId/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedWatchPartyPartyIdRecapRoute = AuthenticatedWatchPartyPartyIdRecapRouteImport.update({
            id: '/watch-party/$partyId/recap',path: '/watch-party/$partyId/recap',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminDemoRoute: AuthenticatedAdminDemoRoute,AuthenticatedAdminReviewRoute: AuthenticatedAdminReviewRoute,AuthenticatedAdminScheduleRoute: AuthenticatedAdminScheduleRoute,AuthenticatedMyReviewIndexRoute: AuthenticatedMyReviewIndexRoute,AuthenticatedWatchPartyIndexRoute: AuthenticatedWatchPartyIndexRoute,AuthenticatedMyReviewCycleIdResultsRoute: AuthenticatedMyReviewCycleIdResultsRoute,AuthenticatedWatchPartyPartyIdRecapRoute: AuthenticatedWatchPartyPartyIdRecapRoute,AuthenticatedMyReviewCycleIdIndexRoute: AuthenticatedMyReviewCycleIdIndexRoute,AuthenticatedWatchPartyPartyIdIndexRoute: AuthenticatedWatchPartyPartyIdIndexRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,R360LeaderCheckRoute: R360LeaderCheckRoute,AboutUsRoute: AboutUsRoute,AuthRoute: AuthRoute,Begin360CheckRoute: Begin360CheckRoute,ContactRoute: ContactRoute,FaqRoute: FaqRoute,GrowRoute: GrowRoute,InsightRoute: InsightRoute,LeadershipGapsAssessmentRoute: LeadershipGapsAssessmentRoute,PilotRoute: PilotRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,PurchaseRoute: PurchaseRoute,ResourcesRoute: ResourcesRoute,ScheduleRoute: ScheduleRoute,SolutionsRoute: SolutionsRoute,StartRoute: StartRoute,TermsAndConditionsRoute: TermsAndConditionsRoute,AuthorSlugRoute: AuthorSlugRoute,BlogSlugRoute: BlogSlugRoute,CaseStudiesSlugRoute: CaseStudiesSlugRoute,CourseCatalogSlugRoute: CourseCatalogSlugRoute,ProblemsSlugRoute: ProblemsSlugRoute,ReviewTokenRoute: ReviewTokenRoute,WhoWeHelpSlugRoute: WhoWeHelpSlugRoute,BlogIndexRoute: BlogIndexRoute,CaseStudiesIndexRoute: CaseStudiesIndexRoute,CourseCatalogIndexRoute: CourseCatalogIndexRoute,ProblemsIndexRoute: ProblemsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)